import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Breadcrumbs.module.css';

/**
 * Breadcrumbs Component
 * Laravel equivalent: Breadcrumbs::render() from davejamesmiller/laravel-breadcrumbs
 * Displays hierarchical navigation trail
 */
const Breadcrumbs = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <ol className={styles.breadcrumb}>
      {items.map((item, index) => {
        // Support multiple naming conventions: label/name for text, link/href/path for URL
        const label = item.label || item.name;
        const link = item.link || item.href || item.path;
        const isLast = index === items.length - 1;
        // Item is non-clickable if: active flag, last item, empty link, or "#" link
        const isNonClickable = item.active || isLast || !link || link === '' || link === '#';

        return (
          <li
            key={index}
            className={isNonClickable ? styles.active : ''}
          >
            {isNonClickable ? (
              <span>{label}</span>
            ) : (
              <Link to={link}>{label}</Link>
            )}
          </li>
        );
      })}
    </ol>
  );
};

export default Breadcrumbs;
